import type { PayloadAction } from '@reduxjs/toolkit';
import { createSlice } from '@reduxjs/toolkit';

const initialState = null as null | number;

const slice = createSlice({
  name: 'creditLoyaltyThreshold',
  initialState,
  reducers: {
    setCreditLoyaltyThreshold(state, action: PayloadAction<number>) {
      return action.payload;
    },
  },
});

export const { setCreditLoyaltyThreshold } = slice.actions;

export default slice.reducer;
